import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import Header from '../components/Header'
import Footer from '../components/Footer'
import './index.css'
import '../styles/style.sass'
import { query } from '../pages';

const TemplateWrapper = ({ children, data }) => (
  <div>
    <Helmet
      title="Muvko - Kruhové tréninky"
      meta={[
        { name: 'description', content: 'Jsme parta sportovních nadšenců, kteří rádi dávají pořádně do těla a rádi se při tom baví. Přidej se k nám!' },
        { name: 'keywords', content: 'muvko, trénink, kruháč, fitness, kruhový trénink, fukční trénink, gym' },
      ]}
    >
      <link href="https://fonts.googleapis.com/css?family=Catamaran:200,700|Slabo+27px&amp;subset=latin-ext" rel="stylesheet" />
    </Helmet>
    <Header logo={data.logoImage} />
    <div className="wrapper">
      {children()}
    </div>
    <Footer />
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper

export const logoQuery = graphql`
query Image {
  logoImage: imageSharp(id: {regex: "/muvko-logo/"}) {
    resolutions(width: 300, quality: 100) {
      width
      height
      src
      srcSet
      srcWebp
      srcSetWebp
      originalName
    }
  }
}
`



// WEBPACK FOOTER //
// ./src/layouts/index.js